import React, {useEffect} from 'react';
import BtnSelect from '../../../Shared/Buttons/BtnSelect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const ChooseNumberToInstallEsim = (props) => {
  useEffect(() => {
    if (props?.phoneDataList.length == 1) {
      props.nextPage();
      handlerChooseNumber(props.phoneDataList[0]);
    }
  }, []);

  const handlerChooseNumber = (item) => {
    if (item.stickerNumber !== null && item.stickerNumber !== undefined && item.stickerNumber !== '') {
      props.setIsCurrentPhoneLoad(false);
      props.setPhoneData(item);
      return null;
    } else {
      props.setPhoneData(item);
    }
  };

  const moveNextPage = () => {
    if (props.isCurrentPhoneLoad) {
      props.setIsNumberChosen(true);
      props.nextPage();
    } else {
      props.setIsNumberChosen(false);
      return null;
    }
  };

  return (
    <div className='choose-number-main-container'>
      <div className='choose-number-text-container'>
        <p className='choose-number-main-title' dangerouslySetInnerHTML={{__html: props.iContent.chooseNumberMainTitle.value}} />
        <p className='choose-number-sub-title' dangerouslySetInnerHTML={{__html: props.iContent.chooseNumberSecondTitle.value}} />
      </div>
      <div className='choose-numbers-container'>
        {props?.saleDataList &&
          props.saleDataList?.map((item) => (
            <BtnSelect
              key={item.id}
              text={item.phoneNumber}
              border={`${props.currentPhone?.id == item.id && props.isCurrentPhoneLoad ? 'selected' : 'unselected'}`}
              onClick={() => {
                handlerChooseNumber(item);
              }}
            />
          ))}
        {props.niudDataList.length !== 0 ? (
          <div className='niud-number-main-container'>
            {props.niudDataList.map((item) => (
              <div
                className='niud-number-container'
                onClick={() => {
                  handlerChooseNumber(item);
                }}>
                <label className='nuid-number-label'>{item.phoneNumber}</label>
              </div>
            ))}
            <div className='vertical-line-choose' />
            <p className='niud-instauration-text'>
              את ה-ESIM בקו זה ניתן להפעיל רק אחרי סיום ניוד הקו ל{window.Config.brand_Name_HE}. הנחיות לביצוע הניוד נשלחו אליכם בסמס.
            </p>
          </div>
        ) : null}
      </div>
      <div className={`footer-button-container`}>
        <BtnSubmit onclick={() => moveNextPage()} text='המשך' />
      </div>
      {!props.isNumberChosen && !props.isCurrentPhoneLoad ? (
        <div className='short-description-choose-one-option-esim'>
          <label>יש לבחור באחת האפשרויות</label>
        </div>
      ) : null}
    </div>
  );
};

export default ChooseNumberToInstallEsim;
